import { BRAND } from '@/config/brand';
import { LogoMark } from '@/components/ui/Logo';

/** Shown for the few milliseconds it takes to hydrate settings from storage. */
export function BootSplash() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas">
      <div className="flex flex-col items-center gap-4">
        <LogoMark className="size-10 animate-pulse" />
        <span className="sr-only">Loading {BRAND.name}</span>
      </div>
    </div>
  );
}
